import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class VwUserGroups extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'VwUserGroups'
  // Use group_id as the unique key since the VIEW's `id` comes from users.id (via u.*)
  // which causes deduplication when multiple groups share the same owner
  static idField = 'group_id'
  // Define default properties here
  static instanceDefaults() {
    return {
      email: '',
      password: ''
    }
  }
}
const servicePath = 'vw-user-groups';
const servicePlugin = makeServicePlugin({
  Model: VwUserGroups,
  service: feathersClient.service(servicePath),
  servicePath,
  idField: 'group_id'
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin